<div class="container custom-container">
    <div class="row">
        <div class="col-auto p-0">
            <app-sidenav></app-sidenav>
        </div>
        <div class="col p-0">
            <div class="p-0 mt-0" style="background-color: #ffff ;width: 100%;height: 100%;">
                <app-header></app-header>
                <div class="main-block">
                    <h3 style="border-bottom: 1px solid grey;padding: 10px;"> <mat-icon
                            style="color: rgb(77, 10, 97); font-size: 33px;position: relative;top:7px;right: 10px;">support_agent</mat-icon>
                        Help Desk Admin</h3>
                    <div class="box">
                        <div class="form-group mb-3">
                            <label for="roleType">Catagory </label>
                            <select id="roleType" placeholder="roleType" [(ngModel)]="selectedCategoryId" (change)="CategoryFilter()"
                                name="roleType" style="padding-left: 15px;">

                                <option value="0">Select Category</option>

                                <option *ngFor="let role of catagoryDropDown" [value]="role.categoryId">
                                    {{ role.categoryName }}
                                </option>
                            </select>


                            
                        </div>
                        <div class="form-group mb-3" *ngIf="selectedCategoryId!=0">
                        <label for="helpdeskAssigner">Choose the Help Desk Admin</label>
                        <select id="helpdeskAssigner" [(ngModel)]="selectedAssigner">
                            <option value=0 [disabled]="true">Select Help Desk Admin</option>

                            <option *ngFor="let role of this.filterList" value="{{role.supportId}}"
                                [disabled]="disabled.includes(role.supportId)">{{role.firstName}}</option>
                        </select>
                        
                    </div>
                    <button class="sync-btn" style="margin: 15px;" (click)="submit()"
                        [disabled]="selectedAssigner==0">Submit</button>
                  
                        <ng-select

  [(ngModel)]="selectedAssigners"
  [items]="supportList"
  bindLabel="firstName"
  bindValue="supportId"
  placeholder="Select Assigners"
  [multiple]="true"
  [closeOnSelect]="false"
  [clearable]="true">
</ng-select>


                    </div>
                </div>

            </div>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, .6)" class="spin-img" template="<img src='assets/img/logo-D.gif' />">
    </ngx-spinner>